   <template>
    <div>
    <v-card class="mx-auto" light :loading="loading">
       <v-card-title>
            <div class="flex-grow-1"></div>
            <v-card-actions>
                <v-btn small color="blue-grey" dark @click="agregar = true">Agregar transferencia</v-btn>
            </v-card-actions>
        </v-card-title>
      <div style=" display: flex; align-items: center; justify-content: end;"> 
      <v-col cols="6" >
        <v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Buscar"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </div>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="transferenciasList"
                :search="search"
                locale="es-mx"
                :footer-props="{
                    'items-per-page-all-text':'Todos',
                    'items-per-page-text':'Columnas'
                }"
            >
             <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.name">  
                        <td> {{item.fechaTransferencia}}</td>
                        <td> {{item.status}}</td>
                        <td> {{item.elaboro}}</td>
                        <td> {{item.expedientesTotal}}</td>
                        <td>
                            <v-btn v-if="!item.transferido" color="blue-grey" dark @click="addExpedientes=true, transf=item" :disabled="loading" :loading="loading">
                                Agregar expedientes
                            </v-btn>
                             <v-btn v-else color="blue-grey" dark text>
                                Expediente ya transferido
                            </v-btn>
                        </td>
                          <td>
                            <!-- <v-btn color="blue-grey" dark @click="getArchivoTransferencia(item._id)" :disabled="loading" :loading="loading">
                                Descargar archivo de transferencia
                            </v-btn> -->
                            <documentoTransferencia v-if="verFormulario" :mostrar="verFormulario" @cancelar="verFormulario = false" @getArchivoTransferencia="verFormulario = false, getArchivoTransferencia()"/>
                              <v-btn dark color="blue-grey" @click="verFormulario = true">
                                <v-icon dense>
                                    mdi-file
                                </v-icon>
                            </v-btn>
                            

                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card-text>
        
            
    </v-card>
    <agregar-transferencia v-if="agregar" :mostrar="agregar" @cancelar="agregar=false" @agregada="agregada"/>
    <agregar-expedientes v-if="addExpedientes" :mostrar="addExpedientes"
    @cancelar="addExpedientes=false, transf=null" :transferencia="transf" @expeAgregado="expeAgregado"/>
    </div>
</template>
<script>
import { getTransferencias,getArchivo } from './transferencias.service'
import AgregarTransferencia from './agregarTransferencia.vue'
import { DateTime } from 'luxon'
import AgregarExpedientes from './agregarExpedientesTransferencias.vue'
import documentoTransferencia from "./documentoTransferencia"

export default {
    props:['actualizarTransferencias'],
    components: {
        AgregarTransferencia,
        AgregarExpedientes,
        documentoTransferencia

    },
    data: () => ({
        verFormulario: false,
        loading: false,
        transferencias:[],
        search:'',
        headers: [
            { text: 'Fecha de transferencia', value: 'fecha' },
            { text: 'status', value:'status' },
            { text: 'Elaboró', value:'elaboro' },
            { text: "Cantidad de expedientes", value:'expedientes' },
            { text: ' ', value:'addExpedientes' },
            { text: ' ', value: 'download' }
        ],
        agregar:false,
        addExpedientes:false,
        transf:null
       
    }),
    computed: {
        transferenciasList(){
            let l = []
            if(this.transferencias.length){
                 this.transferencias.forEach(x=>{
                    // console.log(x);
                    let obj = {
                        _id: x._id,
                        status:x.status,
                        elaboro:x.elaboro.nombreCompleto,
                        fechaTransferencia: this.fechaTexto(x.fechaTransferencia),
                        expedientesTotal:x.expedientes.length,
                        expedientes:x.expedientes

                    }
                    l.push(obj)
                 })
            }
            return l
        }
        
    },
    async created(){
       try {
            this.loading=true;
            const serverResponse = await getTransferencias();
            this.loading=false;
            if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
            this.transferencias = serverResponse.transferencias
        } catch (error) {

            this.$notificarError(error);
        }
       
    },
    methods: {
        agregada(x){
            this.transferencias.push(x)
        },
        fechaTexto(fecha){
            return DateTime.fromISO(fecha).toFormat('dd - MM - yyyy')
        },
        expeAgregado(data){
            let index = this.transferencias.findIndex(x=>x._id == data.idTransferencia)
            this.transferencias[index].expedientes.push(data.id);
            this.transferencias[index].expedientesTotal=this.transferencias[index].expedientesTotal+1
        },
        async getArchivoTransferencia(id){
            try {
                this.loading = true;
                const data = {
                    campo1: 'diez treinta',
                    campo2: 'trece de diciembre de dos mil veinti cuatro',
                    campoCC:'CC',
                    campo3: 'Responsable del archivo de trámite (cargo & nombre)',
                    campo4: 'Coordinación de transparencia y Archivo General ',
                    campo5: '(número de oficio)',
                    campo6: 'doce de diciembre de dos mil veinti cuatro',
                    campo7: '(nombre & cargo)',
                    campo8: '(número de oficio)',
                    campo9: 'doce de diciembre de dos mil veinti cuatro',
                    campo10: '(el / la)',
                    campo11: '(nombre)',
                    campo12: '(cargo del campo 11)',
                    campo13: '(el / la)',
                    campo14: '(nombre)',
                    campo15: '(cargo del campo 14)',
                    campo16: '(número de oficio)',
                    campo17: '(fecha de oficio de campo 16)',
                    campo18: 'XX',
                    campo19: 'XX',
                    campo20: '(número de oficio)',
                    campo21: '(fecha de oficio)'

                }
                const serverResponse = await getArchivo(data);
                this.loading = false;
                const url = window.URL.createObjectURL(new Blob([serverResponse]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", 'doc.pdf');
                link.click();
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.$notificarError(error);
            }

        }
        

    }
}
</script>